<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 194.461"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M54.488 95.342c-5.414,-25.464 -3.672,-37.165 2.428,-68.837 -3.772,-8.066 -17.149,33.124 -9.285,70.602 1.742,-0.526 3.646,-0.897 6.857,-1.765z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M63.78 152.636c0.895,13.42 0.888,25.555 -0.02,36.404 14.765,0.846 23.757,-3.622 20.94,-34.515 -5.966,-1.219 -12.939,-1.849 -20.92,-1.889z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M63.76 189.04c0.908,-10.849 0.915,-22.984 0.02,-36.404 -9.969,4.011 -19.279,5.315 -28.072,4.718 -2.421,13.664 -4.969,23.864 -7.643,30.6 5.764,0.285 12.154,-0.981 17.379,-0.951 6.685,0.698 12.891,1.727 18.316,2.037z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M28.065 187.954c2.674,-6.736 5.222,-16.936 7.642,-30.6 -1.924,-8.253 -9.644,-11.161 -20.446,-12.142 -7.679,35.439 1.317,42.172 12.804,42.742z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M35.708 157.354c8.793,0.597 18.103,-0.707 28.072,-4.718 -0.494,-7.425 -1.265,-15.242 -2.311,-23.454 -8.25,-0.592 -15.24,-2.158 -20.971,-4.697 -1.538,12.574 -3.135,23.531 -4.79,32.869z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M61.469 129.182c1.046,8.212 1.817,16.029 2.311,23.454 7.981,0.04 14.954,0.67 20.92,1.889 -0.09,-0.994 -0.193,-2.015 -0.308,-3.064 -0.172,-8.812 -1.56,-16.269 -3.781,-22.462 -6.996,0.536 -13.377,0.597 -19.142,0.183z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M61.469 129.182c5.765,0.414 12.146,0.353 19.142,-0.183 -6.113,-17.038 -18.536,-24.514 -29.319,-24.326 -7.559,0.132 -15.469,4.667 -22.033,11.957 2.958,3.228 6.704,5.846 11.239,7.855 5.731,2.539 12.721,4.105 20.971,4.697z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M35.708 157.354c1.655,-9.338 3.252,-20.295 4.79,-32.869 -4.535,-2.009 -8.281,-4.627 -11.239,-7.855 -4.402,4.889 -8.199,11.018 -10.878,17.888 -1.098,2.814 -2.008,5.752 -2.695,8.781 -0.147,0.647 -0.288,1.285 -0.425,1.911 1.093,0.1 2.154,0.219 3.182,0.362 9.123,1.264 15.534,4.364 17.265,11.782z"
        />

        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M52.557 11.304c6.748,-9.424 11.033,-7.753 12.854,5.012"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M15.686 143.299c4.868,-21.45 20.902,-38.369 35.606,-38.626 14.703,-0.257 32.457,13.739 33.1,46.788 5.013,45.647 -13.483,38.202 -38.948,35.542 -15.824,-0.09 -42.333,11.703 -29.758,-43.704zm64.925 -14.3c-6.43,-32.478 -11.496,-70.039 -15.2,-112.683m-12.854 -5.012c-5.769,7.716 -11.424,19.003 -13.241,34.448 -2.88,24.48 -8.773,54.125 -20.935,88.766"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
